import { Box, Button, Flex, Heading, Text } from '@chakra-ui/react'
import { Loading } from '@components'
import { GearIcon, MapMarkerIcon } from '@components/icons'
import React, { useState } from 'react'
import { useQueryClient } from 'react-query'
import {
  getClinicControllerGetClinicLocationQueryKey,
  useClinicControllerDeleteClinicLocation,
  useClinicControllerGetClinicLocation
} from '~/clinician-api'
import { OfficeLocationModal } from './office-location.modal'

export const Location = ({ clinic }: { clinic: any }) => {
  const [isOpen, setIsOpen] = useState(false)
  const queryClient = useQueryClient()
  const { data: clinicLocation, isLoading } =
    useClinicControllerGetClinicLocation(clinic.id)
  const { mutate: deleteClinicLocation } =
    useClinicControllerDeleteClinicLocation({
      mutation: {
        onSuccess: () => {
          queryClient.invalidateQueries(
            getClinicControllerGetClinicLocationQueryKey(clinic.id)
          )
        }
      }
    })

  if (isLoading) {
    return <Loading />
  }

  return (
    <Box w="100%">
      <Heading size="small" mb="xs">
        Location
      </Heading>
      <Text mb="small">
        Add your office location so we can include it in relevant client
        messages
      </Text>
      {clinicLocation ? (
        <Flex
          justifyContent="space-between"
          alignItems="center"
          border="1px solid"
          borderColor="pale_gray"
          p="small"
          borderRadius="8px"
        >
          <Flex alignItems="center" gap="medium">
            <Box bg="#F4F4F4" p="xsmall" borderRadius="8px">
              <MapMarkerIcon />
            </Box>
            <Text>
              {clinicLocation.displayName && (
                <Text as="span" fontWeight="bold" mr="small">
                  {clinicLocation.displayName}
                </Text>
              )}
              {clinicLocation.addressLine1 &&
                `${clinicLocation.addressLine1}, `}
              {clinicLocation.addressLine2 &&
                `${clinicLocation.addressLine2}, `}
              {clinicLocation.city && `${clinicLocation.city}, `}
              {clinicLocation.state && `${clinicLocation.state} `}
              {clinicLocation.postalCode}
            </Text>
          </Flex>
          <Flex gap="xsmall">
            <Button
              variant="outline"
              onClick={() => setIsOpen(true)}
              borderRadius="8px"
              m="0px"
            >
              <GearIcon />
            </Button>
            <Button
              variant="outline"
              onClick={() =>
                deleteClinicLocation({
                  clinicId: clinic.id
                })
              }
              borderRadius="8px"
              m="0px"
            >
              Delete
            </Button>
          </Flex>
        </Flex>
      ) : (
        <Button onClick={() => setIsOpen(true)} m="0px">
          Add Location
        </Button>
      )}
      <OfficeLocationModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        clinicLocation={clinicLocation}
        clinicId={clinic.id}
      />
    </Box>
  )
}
